document.addEventListener('DOMContentLoaded', () => {

  const searchPopup =
    document.querySelector('.custom-search');

  const openButtons =
    document.querySelectorAll('.custom-search-toggle');

  const closeButton =
    document.querySelector('.custom-search__close');

  const overlay =
    document.querySelector('.custom-search__overlay');

  const input =
    document.querySelector('.custom-search__input');

  const results =
    document.querySelector('.custom-search__grid');

  if (!searchPopup) return;

  // OPEN SEARCH

  openButtons.forEach((button) => {

    button.addEventListener('click', (e) => {

      e.preventDefault();

      searchPopup.classList.add('active');

      setTimeout(() => {

        input.focus();

      }, 200);

    });

  });

  // CLOSE SEARCH

  function closeSearch() {

    searchPopup.classList.remove('active');

  }

  closeButton.addEventListener(
    'click',
    closeSearch
  );

  overlay.addEventListener(
    'click',
    closeSearch
  );

  // ESC CLOSE

  document.addEventListener('keydown', (e) => {

    if (e.key === 'Escape') {

      closeSearch();

    }

  });

  // CLICK OUTSIDE CLOSE

  document.addEventListener('click', function (e) {

    const modal =
      document.querySelector('.custom-search__modal');

    const toggle =
      document.querySelector('.custom-search-toggle');

    if (
      searchPopup.classList.contains('active') &&
      !modal.contains(e.target) &&
      !toggle.contains(e.target)
    ) {

      closeSearch();

    }

  });

  // PREDICTIVE SEARCH

  let timeout;

  input.addEventListener('input', () => {

    clearTimeout(timeout);

    const query =
      input.value.trim();

    // EMPTY

    if (query.length < 2) {

      results.innerHTML = '';

      return;

    }

    timeout = setTimeout(async () => {

      try {

        const response = await fetch(
          `/search/suggest?q=${query}&resources[type]=product&section_id=predictive-search`
        );

        const text =
          await response.text();

        const html =
          new DOMParser()
          .parseFromString(text, 'text/html');

        const products =
          html.querySelectorAll(
            '.predictive-search__list-item'
          );

        results.innerHTML = '';

        // DEBUG

        console.log('FULL HTML:', html);

        console.log('PRODUCTS:', products);

        // NO RESULTS

        if (!products.length) {

          results.innerHTML = `
            <div class="custom-search__empty">
              No products found
            </div>
          `;

          return;

        }

        products.forEach((product) => {

          console.log(
            'PRODUCT HTML:',
            product.innerHTML
          );

          const link =
            product.querySelector('a');

          const image =
            product.querySelector('img');

          const title =
            product.querySelector(
              '.predictive-search__item-heading'
            );

          // PRICE

          const price =
            product.querySelector('.predictive-search__item-price')
            || product.querySelector('.price')
            || product.querySelector('.price-item')
            || product.querySelector('.price-item--regular');

          console.log(
            'PRICE ELEMENT:',
            price
          );

          results.innerHTML += `

            <a
              href="${link ? link.href : '#'}"
              class="custom-search__item"
            >

              <div class="custom-search__image">

                <img
                  src="${image ? image.src : ''}"
                  alt="${title ? title.textContent.trim() : ''}"
                >

              </div>

              <div class="custom-search__title">

                ${title ? title.textContent.trim() : ''}

              </div>

              <div class="custom-search__price">

                ${price ? price.textContent.trim() : ''}

              </div>

              <button
                class="custom-search__button"
              >

                SHOP NOW

              </button>

            </a>

          `;

        });

      } catch (error) {

        console.log(
          'Predictive search error:',
          error
        );

      }

    }, 300);

  });

});